export const CANONICAL_EVENTS = [
  'USER_SIGNED_UP',
  'EMAIL_CONFIRMED',
  'ONBOARDING_STARTED',
  'ONBOARDING_COMPLETED',
  'USER_ACTIVATED',
  'GOLF_BAG_CREATED',
  'CLUB_ADDED',
  'DISTANCES_COMPLETED',
  'SHOT_ADVISOR_USED',
  'CLUB_OPTIMIZER_USED',
  'AI_CHAT_USED',
  'AUTHENTICATED_SESSION',
  'SIGNUP_STARTED',
] as const;

export type CanonicalEventName = typeof CANONICAL_EVENTS[number];

export interface ActivationSnapshot {
  hasCompletedOnboarding?: boolean;
  golfBag?: unknown;
  clubDistances?: unknown;
}

function isNonEmptyArray(value: unknown): boolean {
  return Array.isArray(value) && value.length > 0;
}

/** Canonical activation: onboarding completed, non-empty bag, populated distances. */
export function isActivatedUser(snapshot: ActivationSnapshot): boolean {
  return (
    snapshot.hasCompletedOnboarding === true &&
    isNonEmptyArray(snapshot.golfBag) &&
    isNonEmptyArray(snapshot.clubDistances)
  );
}

export const BANNED_EVENT_PROPERTY_KEYS = [
  'email',
  'birthdate',
  'ip',
  'prompt',
  'message',
  'password',
  'token',
];

export function isSafeEventProperties(properties: Record<string, unknown>): boolean {
  return !Object.keys(properties).some((key) =>
    BANNED_EVENT_PROPERTY_KEYS.includes(key.toLowerCase())
  );
}
